import React, {useContext} from 'react'
import {makeStyles} from 'external/material'
import {TeacherContext} from 'teacher/context'

const useStyles = makeStyles(indicatorStyles)

export default function Indicators () {
  const context = useContext(TeacherContext)
  const classes = useStyles()
  const {standardsContext, questionId} = context
  const {assessmentIndicators} = standardsContext
  const indicators = assessmentIndicators[questionId] || []

  return (
    <div className={classes.root}>
      {indicators.map(({id, code}) => (<div key={id} className={classes.code}>{code}</div>))}
    </div>
  )
}

function indicatorStyles() {
  return {
    root: {
      display: 'flex',
    },
    code: {
      marginLeft: 10,
      minWidth: 80,
      textAlign: 'center',
      textTransform: 'uppercase',
      fontWeight: 'bold',
      backgroundColor: '#40f993',
      borderRadius: 3,
      fontSize: '11pt',
      padding: '3px 16px',
      color: '#4b5463'
    },
  }
}
